import {
  gql,
  type MutationHookOptions,
  type OperationVariables,
  type QueryHookOptions,
  useMutation,
  useQuery,
} from '@apollo/client';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';

type JsonQuery = Record<string, unknown>;

export function useBuildQuery<TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  jsonQuery: JsonQuery,
  options?: QueryHookOptions<TData, TVariables>,
) {
  const query = jsonToGraphQLQuery(jsonQuery);
  return useQuery<TData, TVariables>(gql(query), options);
}

export function useBuildMutation<TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  jsonQuery: JsonQuery,
  options?: MutationHookOptions<TData, TVariables>,
) {
  const query = jsonToGraphQLQuery(jsonQuery);
  return useMutation<TData, TVariables>(gql(query), options);
}
